import { Market } from '@shared/config/market/market.models';
import { semboAssets } from '@shared/config/market/market.assets';
import {
    OUR_POLICIES_PATH,
    TRAVEL_CONDITIONS_PATH,
} from '@shared/config/market/data/market.data.consts';

const globalFooterInfo = [
    [
        {
            text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
            text: 'Registration number: 556529-1795',
        },
        {
            text: 'Registered office: Helsingborg, Sweden',
        },
    ],
    [
        {
            text: 'Privacy Policy',
            href: OUR_POLICIES_PATH,
        },
        {
            text: `Sembo's terms and conditions`,
            href: TRAVEL_CONDITIONS_PATH,
        },
        {
            text: 'Work at Sembo',
            href: 'https://career.sembo.com/',
        },
    ],
];
const spanishFooterInfo = [
    [
        {
            text: 'Kungsgatan 6, 252 21 Helsingborg, Suecia',
        },
        {
            text: 'Número de registro: 556529-1795',
        },
        {
            text: 'Oficina registrada: Helsingborg, Suecia',
        },
    ],
    [
        {
            text: 'Política de privacidad',
            href: OUR_POLICIES_PATH,
        },
        {
            text: 'Condiciones de viaje de Sembo',
            href: TRAVEL_CONDITIONS_PATH,
        },
        {
            text: 'Trabaja en Sembo',
            href: 'https://career.sembo.com/',
        },
    ],
];
const dutchFooterInfo = [
    [
        {
            text: 'Kungsgatan 6, 252 21 Helsingborg, ZWEDEN',
        },
        {
            text: 'Registratie nummer: 556529-1795',
        },
        {
            text: 'Statutaire zetel: Helsingborg, Zweden',
        },
    ],
    [
        {
            text: 'Privacybeleid',
            href: OUR_POLICIES_PATH,
        },
        {
            text: 'Reisvoorwaarden van Sembo',
            href: TRAVEL_CONDITIONS_PATH,
        },
        {
            text: 'Werk bij Sembo',
            href: 'https://career.sembo.com/',
        },
    ],
];

export const semboSwedishCompanyData: Market = {
    number: 1,
    domain: 'sembo.se',
    isSubdomain: false,
    locale: 'sv',
    fullLocale: 'sv-SE',
    name: 'Sembo',
    homePage: 'https://www.sembo.se',
    supportPhone: '+46 10 884 8050',
    priorityPhone: '+46 42 623 2114',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    links: {
        newsletter: 'https://www.sembo.se/nyhetsbrev',
        sembonus: 'https://www.sembo.se/sembonus',
    },
    insurance: {
        baggage: {
            compensation: {
                Amount: 7000,
                Currency: 'SEK',
            },
            generalTerms: 'https://www.solidab.se/villkor/lankar/SE/bagageforsakring.pdf',
            purchaseTerms:
                'https://www.solidab.se/villkor/lankar/SE/FoE_bagageforsakring.pdf',
        },
        travel: {
            compensation: {
                Amount: 30000,
                Currency: 'SEK',
            },
            generalTerms: 'https://www.solidab.se/villkor/lankar/SE/reseforsakringplus.pdf',
            purchaseTerms:
                'https://www.solidab.se/villkor/lankar/SE/FoE_reseforsakringplus.pdf',
        },
    },
    footerInfo: [
        [
            {
                text: 'Org nr: 556529-1795',
            },
            {
                text: 'Momsreg. nr: SE556529179501',
            },
            {
                text: 'Styrelsens säte: Helsingborg',
            },
        ],
        [
            {
                text: 'Om Sembo',
                href: 'https://www.sembo.se/om-oss.aspx',
            },
            {
                text: 'Jobba på Sembo',
                href: 'https://career.sembo.se/',
            },
            {
                text: 'Login för reseagenter',
                href: 'http://agent-se.sembo.se/agent/default.aspx',
            },
            {
                text: 'Vi innehar statlig resegaranti ställd hos Kammarkollegiet',
                href: 'https://www.kammarkollegiet.se/vara-tjanster/resegaranti',
            },
        ],
        [
            {
                text: 'Flygbolag - kontakt och villkor',
                href: 'https://www.sembo.se/saa-reser-du/flyg/flygbolag.aspx',
            },
            {
                text: 'EU:s svartlistade flygbolag',
                href: 'http://ec.europa.eu/transport/modes/air/safety/air-ban/index_sv.htm',
            },
            {
                text: 'Lufttrafikföretags skadeståndsansvar vid olyckor',
                href: 'http://eur-lex.europa.eu/LexUriServ/LexUriServ.do?uri=OJ:L:2002:140:0002:0005:EN:PDF',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: '.',
        currency: 'SEK',
        currencySymbol: 'kr',
    },
};

export const semboNorwegianCompanyData: Market = {
    number: 4,
    domain: 'sembo.no',
    isSubdomain: false,
    locale: 'no',
    fullLocale: 'nb-NO',
    name: 'Sembo',
    homePage: 'https://www.sembo.no',
    supportPhone: '+47 21 99 94 50',
    priorityPhone: '+47 23 50 69 75',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    links: {
        newsletter:
            'https://www.sembo.no/bestill-och-ladda-ner/abonner-paa-sembos-nyhetsbrev',
        sembonus: 'https://www.sembo.no/sembonus',
    },
    insurance: {
        baggage: {
            compensation: {
                Amount: 7000,
                Currency: 'NOK',
            },
            generalTerms: 'https://www.solidab.se/villkor/lankar/NO/bagageforsikring.pdf',
            purchaseTerms:
                'https://www.solidab.se/villkor/lankar/NO/FoE_bagageforsikring.pdf',
        },
        travel: {
            compensation: {
                Amount: 30000,
                Currency: 'NOK',
            },
            generalTerms:
                'https://www.solidab.se/villkor/lankar/NO/enkeltreiseforsikring.pdf',
            purchaseTerms:
                'https://www.solidab.se/villkor/lankar/NO/FoE_enkeltreiseforsikring.pdf',
        },
    },
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 HELSINGBORG, SVERIGE',
            },
            {
                text: 'Registreringsnummer: 556529-1795',
            },
            {
                text: 'Registrert kontor: Helsingborg',
            },
        ],
        [
            {
                text: 'Om Sembo',
                href: 'https://www.sembo.no/om-oss.aspx',
            },
            {
                text: 'Retningslinjer for personvern',
                href: OUR_POLICIES_PATH,
            },
            {
                text: 'Reisevilkår',
                href: TRAVEL_CONDITIONS_PATH,
            },
        ],
        [
            {
                text: 'Affiliate-partner',
                href: 'https://www.sembo.no/om-sembo/affiliate-partner.aspx',
            },
            {
                text: 'Work at sembo',
                href: 'https://career.sembo.com/',
            },
            {
                text: 'Innlogging for reisebyråer',
                href: 'https://sembok2.sembo.se/sembok2/login.aspx',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: '.',
        currency: 'NOK',
        currencySymbol: 'kr',
    },
};

export const semboDanishCompanyData: Market = {
    number: 5,
    domain: 'sembo.dk',
    isSubdomain: false,
    locale: 'da',
    fullLocale: 'da-DK',
    name: 'Sembo - tidligere DTF Travel',
    homePage: 'https://www.sembo.dk',
    supportPhone: '+45 78 75 49 00',
    priorityPhone: '+45 35 15 29 99',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    links: {
        newsletter: 'https://www.sembo.dk/bestil-og-download/nyhedsbrev/',
        sembonus: 'https://www.sembo.dk/sembonus',
    },
    insurance: {
        baggage: {
            compensation: {
                Amount: 7000,
                Currency: 'DKK',
            },
            generalTerms: 'https://www.solidab.se/villkor/lankar/DK/bagageforsikring.pdf',
            purchaseTerms:
                'https://www.solidab.se/villkor/lankar/DK/FoE_bagageforsikring.pdf',
        },
        travel: {
            compensation: {
                Amount: 30000,
                Currency: 'DKK',
            },
            generalTerms: 'https://www.solidab.se/villkor/lankar/DK/rejseforsikring.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/DK/FoE_rejseforsikring.pdf',
        },
    },
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SVERIGE',
            },
            {
                text: 'Registreringsnummer: 556529-1795',
            },
            {
                text: 'Registreret kontor: Helsingborg, Sverige',
            },
        ],
        [
            {
                text: 'Privatlivspolitik',
                href: OUR_POLICIES_PATH,
            },
            {
                text: 'Sembo Rejsebetingelser',
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Arbejde hos Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: '.',
        currency: 'DKK',
        currencySymbol: 'kr',
    },
};

export const semboFinnishCompanyData: Market = {
    number: 6,
    domain: 'sembo.fi',
    isSubdomain: false,
    locale: 'fi',
    fullLocale: 'fi-FI',
    name: 'Sembo',
    homePage: 'https://www.sembo.fi',
    supportPhone: '+358 9 425 50490',
    priorityPhone: '+358 8 587 19527',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    links: {
        newsletter: 'https://www.sembo.fi/bestaell-och-ladda-ner/sembon-uutiskirje.aspx',
    },
    insurance: {
        baggage: {
            compensation: {
                Amount: 700,
                Currency: 'EUR',
            },
            generalTerms: 'https://www.solidab.se/villkor/lankar/FI/matkatavaravakuutus.pdf',
            purchaseTerms:
                'https://www.solidab.se/villkor/lankar/FI/FoE_matkatavaravakuutus_Bagage_eti.pdf',
        },
        travel: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/FI/matkavakuutus.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/FI/FoE_matkavakuutus.pdf',
        },
    },
    footerInfo: [
        [
            {
                text: 'Stena Line Travel Group AB, Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
            },
            {
                text: 'Puh. 09 - 4255 0490 (arkisin klo 09-17)',
            },
            {
                text: 'Asiakaspalvelun sähköposti: asiakaspalvelu@sembo.fi',
            },
        ],
        [
            {
                text: 'Tietoa Sembosta',
                href: 'https://www.sembo.fi/tietoa-sembosta.aspx',
            },
            {
                text: 'Privacy Policy',
                href: OUR_POLICIES_PATH,
            },
            {
                text: 'Matkaehdot',
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Tietoa Sembo.fi',
                href: 'https://www.sembo.fi/tietoa-sembosta/tietoa-sembofi.aspx',
            },
            {
                text: 'Working at Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboGermanCompanyData: Market = {
    number: 7,
    domain: 'sembo.de',
    isSubdomain: false,
    locale: 'de',
    fullLocale: 'de-DE',
    name: 'Sembo',
    homePage: 'https://www.sembo.de',
    supportPhone: '+49 381 770 24826',
    priorityPhone: '+49 381 768 73199',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    insurance: {
        baggage: {
            compensation: {
                Amount: 700,
                Currency: 'EUR',
            },
            generalTerms:
                'https://www.solidab.se/villkor/lankar/DE/reisegepackversicherung.pdf',
            purchaseTerms:
                'https://www.solidab.se/villkor/lankar/DE/FoE_reisegepackversicherung.pdf',
        },
        travel: {
            generalTerms:
                'https://www.solidab.se/villkor/lankar/DE/europaweite_reiseversicherung.pdf',
            purchaseTerms:
                'https://www.solidab.se/villkor/lankar/DE/FoE_europaweite_reiseversicherung.pdf',
        },
    },
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 HELSINGBORG, SCHWEDEN',
            },
            {
                text: 'Steuer-Nr.: 556529-1795',
            },
            {
                text: 'Sitz der Gesellschaft: Helsingborg',
            },
        ],
        [
            {
                text: 'Über Sembo',
                href: 'https://www.sembo.de/ueber-uns',
            },
            {
                text: 'Datenschutzerklärung',
                href: OUR_POLICIES_PATH,
            },
            {
                text: 'Reisebedingungen',
                href: 'https://www.sembo.de/reisebedingungen',
            },
        ],
        [
            {
                text: 'Insolvenzversicherung von Stena Line Travel Group AB über Kammarkollegiet',
                href: 'https://www.sembo.de/ueber-uns/reisegarantie.aspx',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboPolishCompanyData: Market = {
    number: 8,
    domain: 'sembo.pl',
    isSubdomain: false,
    locale: 'pl',
    fullLocale: 'pl-PL',
    name: 'Sembo',
    homePage: 'https://www.sembo.pl',
    supportPhone: '+48 58 881 03 30',
    priorityPhone: '+48 91 882 15 21',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    insurance: {
        baggage: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Baggage_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Baggage_PL.pdf',
        },
        travel: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Travel_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Travel_PL.pdf',
        },
    },
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, Szwecja',
            },
            {
                text: 'Nr VAT: 556529-1795',
            },
            {
                text: 'Siedziba zarządu: Helsingborg, Szwecja',
            },
        ],
        [
            {
                text: 'Polityka prywatności',
                href: OUR_POLICIES_PATH,
            },
            {
                text: 'Warunki podróży',
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Kariera',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: '.',
        currency: 'PLN',
        currencySymbol: 'zł',
    },
};

export const semboDutchCompanyData: Market = {
    number: 9,
    domain: 'sembo.nl',
    isSubdomain: false,
    locale: 'nl',
    fullLocale: 'nl-NL',
    name: 'Sembo',
    homePage: 'https://www.sembo.nl',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    insurance: {
        baggage: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Baggage_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Baggage_NL.pdf',
        },
        travel: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Travel_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Travel_NL.pdf',
        },
    },
    footerInfo: dutchFooterInfo,
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboBritishCompanyData: Market = {
    number: 10,
    domain: 'sembo.co.uk',
    isSubdomain: false,
    locale: 'en',
    fullLocale: 'en-GB',
    name: 'Sembo',
    homePage: 'https://www.sembo.co.uk',
    supportPhone: '+44 20 8016 0993',
    priorityPhone: '+44 1564 334719',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
            },
            {
                text: 'Registration number: 556529-1795',
            },
            {
                text: 'Registered office: Helsingborg, Sweden',
            },
        ],
        [
            {
                text: 'Privacy Policy',
                href: OUR_POLICIES_PATH,
            },
            {
                text: `Sembo's terms and conditions`,
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Work at Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'GBP',
        currencySymbol: '£',
    },
};

export const semboIrishCompanyData: Market = {
    number: 11,
    domain: 'sembo.ie',
    isSubdomain: false,
    locale: 'en',
    fullLocale: 'en-IE',
    name: 'Sembo',
    homePage: 'https://www.sembo.ie',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    insurance: {
        baggage: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Baggage_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Baggage_IE.pdf',
        },
        travel: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Travel_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Travel_IE.pdf',
        },
    },
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
            },
            {
                text: 'Registration number: 556529-1795',
            },
            {
                text: 'Registered office: Helsingborg, Sweden',
            },
        ],
        [
            {
                text: 'Privacy Policy',
                href: OUR_POLICIES_PATH,
            },
            {
                text: `Sembo's terms and conditions`,
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Work at Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboAustrianCompanyData: Market = {
    number: 12,
    domain: 'sembo.at',
    isSubdomain: false,
    locale: 'de',
    fullLocale: 'de-AT',
    name: 'Sembo',
    homePage: 'https://www.sembo.at',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    insurance: {
        baggage: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Baggage_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Baggage_AT.pdf',
        },
        travel: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Travel_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Travel_AT.pdf',
        },
    },
    footerInfo: [
        [
            {
                text: 'Box 1324, 251 13 HELSINGBORG',
            },
            {
                text: 'Steuer-Nr.: 556529-1795',
            },
            {
                text: 'Sitz der Gesellschaft: Helsingborg',
            },
        ],
        [
            {
                text: 'Über Sembo',
                href: 'https://www.sembo.at/uberblick/',
            },
            {
                text: 'Datenschutzerklärung',
                href: OUR_POLICIES_PATH,
            },
            {
                text: 'Reisebedingungen',
                href: 'https://www.sembo.at/reisebedingungen',
            },
        ],
        [
            {
                text: 'Insolvenzversicherung von Stena Line Travel Group AB über Kammarkollegiet',
                href: 'https://www.sembo.de/ueber-uns/reisegarantie.aspx',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboHungarianCompanyData: Market = {
    number: 13,
    domain: 'sembo.hu',
    isSubdomain: false,
    locale: 'hu',
    fullLocale: 'hu-HU',
    name: 'Sembo',
    homePage: 'https://www.sembo.hu',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    insurance: {
        baggage: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Baggage_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Baggage_HU.pdf',
        },
        travel: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Travel_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Travel_HU.pdf',
        },
    },
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SVÉDORSZÁG',
            },
            {
                text: 'Regisztrációs szám: 556529-1795',
            },
            {
                text: 'Székhely: Helsingborg, Svédország',
            },
        ],
        [
            {
                text: 'Adatvédelmi irányelvek',
                href: OUR_POLICIES_PATH,
            },
            {
                text: 'Sembo szerződési feltételei',
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Munka a Sembonál',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: ',',
        currency: 'HUF',
        currencySymbol: 'Ft',
    },
};

export const semboAustralianCompanyData: Market = {
    number: 14,
    domain: 'sembo.com.au',
    isSubdomain: false,
    locale: 'en',
    fullLocale: 'en-AU',
    name: 'Sembo',
    homePage: 'https://sembo.com.au',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
            },
            {
                text: 'Registration number: 556529-1795',
            },
            {
                text: 'Registered office: Helsingborg, Sweden',
            },
        ],
        [
            {
                text: 'Privacy Policy',
                href: OUR_POLICIES_PATH,
            },
            {
                text: `Sembo's terms and conditions`,
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Work at Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'AUD',
        currencySymbol: '$',
    },
};

export const semboNewZealanderCompanyData: Market = {
    number: 15,
    domain: 'sembo.nz',
    isSubdomain: false,
    locale: 'en',
    fullLocale: 'en-NZ',
    name: 'Sembo',
    homePage: 'https://www.sembo.nz',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
            },
            {
                text: 'Registration number: 556529-1795',
            },
            {
                text: 'Registered office: Helsingborg, Sweden',
            },
        ],
        [
            {
                text: 'Privacy Policy',
                href: OUR_POLICIES_PATH,
            },
            {
                text: `Sembo's terms and conditions`,
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Work at Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'NZD',
        currencySymbol: '$',
    },
};

export const semboNorthAmericanCompanyData: Market = {
    number: 16,
    domain: 'sembo.com',
    isSubdomain: false,
    locale: 'en',
    fullLocale: 'en-US',
    name: 'Sembo',
    homePage: 'https://www.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
            },
            {
                text: 'Registration number: 556529-1795',
            },
            {
                text: 'Registered office: Helsingborg, Sweden',
            },
        ],
        [
            {
                text: 'Privacy Policy',
                href: OUR_POLICIES_PATH,
            },
            {
                text: `Sembo's terms and conditions`,
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Work at Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'USD',
        currencySymbol: '$',
    },
};

export const semboCanadianCompanyData: Market = {
    number: 17,
    domain: 'sembo.ca',
    isSubdomain: false,
    locale: 'en',
    fullLocale: 'en-CA',
    name: 'Sembo',
    homePage: 'https://www.sembo.ca',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
            },
            {
                text: 'Registration number: 556529-1795',
            },
            {
                text: 'Registered office: Helsingborg, Sweden',
            },
        ],
        [
            {
                text: 'Privacy Policy',
                href: OUR_POLICIES_PATH,
            },
            {
                text: `Sembo's terms and conditions`,
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Work at Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'CAD',
        currencySymbol: '$',
    },
};

export const semboSouthAfricanCompanyData: Market = {
    number: 18,
    domain: 'sembo.co.za',
    domainRedirected: 'sembo.com',
    isSubdomain: false,
    locale: 'en',
    fullLocale: 'en-ZA',
    name: 'Sembo',
    homePage: 'https://www.sembo.co.za',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'ZAR',
        currencySymbol: 'R',
    },
};

export const semboSingaporeanCompanyData: Market = {
    number: 19,
    domain: 'sembo.sg',
    domainRedirected: 'sembo.com',
    isSubdomain: false,
    locale: 'en',
    fullLocale: 'en-SG',
    name: 'Sembo',
    homePage: 'https://www.sembo.sg',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: '.',
        currency: 'SGD',
        currencySymbol: '$',
    },
};

export const semboSpanishCompanyData: Market = {
    number: 20,
    domain: 'sembo.es',
    isSubdomain: false,
    locale: 'es',
    fullLocale: 'es-ES',
    name: 'Sembo',
    homePage: 'https://www.sembo.es',
    supportPhone: '+34 518 98 80 00',
    priorityPhone: '+34 871 07 63 74',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    insurance: {
        baggage: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Baggage_generic.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Baggage_ES.pdf',
        },
        travel: {
            generalTerms: 'https://www.solidab.se/villkor/lankar/EU/Travel_ES.pdf',
            purchaseTerms: 'https://www.solidab.se/villkor/lankar/EU/FoE_Travel_ES.pdf',
        },
    },
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboPortugueseCompanyData: Market = {
    number: 21,
    domain: 'sembo.pt',
    isSubdomain: false,
    locale: 'pt',
    fullLocale: 'pt-PT',
    name: 'Sembo',
    homePage: 'https://www.sembo.pt',
    supportPhone: '+34 518 988 000',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SUÉCIA',
            },
            {
                text: 'Número de registro: 556529-1795',
            },
            {
                text: 'Sede registrada: Helsingborg, Suécia',
            },
        ],
        [
            {
                text: 'Política de Privacidade',
                href: OUR_POLICIES_PATH,
            },
            {
                text: 'Termos e condições da Sembo',
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Trabalhe na Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboArabicEmiratesCompanyData: Market = {
    number: 23,
    domain: 'ae.sembo.com',
    isSubdomain: true,
    locale: 'ar',
    fullLocale: 'ar-AE',
    name: 'Sembo',
    homePage: 'https://ae.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
            },
            {
                text: 'Registration number: 556529-1795',
            },
            {
                text: 'Registered office: Helsingborg, Sweden',
            },
        ],
        [
            {
                text: 'Privacy Policy',
                href: OUR_POLICIES_PATH,
            },
            {
                text: `Sembo's terms and conditions`,
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Work at Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'AED',
        currencySymbol: 'د.إ',
    },
};

export const semboBulgarianCompanyData: Market = {
    number: 24,
    domain: 'sembo.bg',
    domainRedirected: 'sembo.com',
    isSubdomain: false,
    locale: 'bg',
    fullLocale: 'bg-BG',
    name: 'Sembo',
    homePage: 'https://www.sembo.bg',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'BGN',
        currencySymbol: 'лв',
    },
};

export const semboCzechCompanyData: Market = {
    number: 25,
    domain: 'cz.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'cs',
    fullLocale: 'cs-CZ',
    name: 'Sembo',
    homePage: 'https://cz.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'CZK',
        currencySymbol: 'Kč',
    },
};

export const semboIndianCompanyData: Market = {
    number: 26,
    domain: 'sembo.in',
    domainRedirected: 'sembo.com',
    isSubdomain: false,
    locale: 'hi',
    fullLocale: 'hi-IN',
    name: 'Sembo',
    homePage: 'https://www.sembo.in',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'INR',
        currencySymbol: '₹',
    },
};

export const semboPhilippineCompanyData: Market = {
    number: 27,
    domain: 'ph.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'en',
    fullLocale: 'en-PH',
    name: 'Sembo',
    homePage: 'https://ph.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'PHP',
        currencySymbol: '₱',
    },
};

export const semboNigerianCompanyData: Market = {
    number: 28,
    domain: 'ng.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'en',
    fullLocale: 'en-NG',
    name: 'Sembo',
    homePage: 'https://ng.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'NGN',
        currencySymbol: '₦',
    },
};

export const semboMexicanCompanyData: Market = {
    number: 29,
    domain: 'sembo.com.mx',
    domainRedirected: 'sembo.es',
    isSubdomain: false,
    locale: 'es',
    fullLocale: 'es-MX',
    name: 'Sembo',
    homePage: 'https://www.sembo.com.mx',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'MXN',
        currencySymbol: '$',
    },
};

export const semboArgentinianCompanyData: Market = {
    number: 30,
    domain: 'sembo.com.ar',
    domainRedirected: 'sembo.es',
    isSubdomain: false,
    locale: 'es',
    fullLocale: 'es-AR',
    name: 'Sembo',
    homePage: 'https://www.sembo.com.ar',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'ARS',
        currencySymbol: '$',
    },
};

export const semboColombianCompanyData: Market = {
    number: 31,
    domain: 'sembo.com.co',
    domainRedirected: 'sembo.es',
    isSubdomain: false,
    locale: 'es',
    fullLocale: 'es-CO',
    name: 'Sembo',
    homePage: 'https://www.sembo.com.co',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'COP',
        currencySymbol: '$',
    },
};

export const semboChileanCompanyData: Market = {
    number: 32,
    domain: 'sembo.cl',
    domainRedirected: 'sembo.es',
    isSubdomain: false,
    locale: 'es',
    fullLocale: 'es-CL',
    name: 'Sembo',
    homePage: 'https://www.sembo.cl',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'CLP',
        currencySymbol: '$',
    },
};

export const semboPeruvianCompanyData: Market = {
    number: 33,
    domain: 'sembo.pe',
    domainRedirected: 'sembo.es',
    isSubdomain: false,
    locale: 'es',
    fullLocale: 'es-PE',
    name: 'Sembo',
    homePage: 'https://www.sembo.pe',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'PEN',
        currencySymbol: 'S/.',
    },
};

export const semboEcuadorianCompanyData: Market = {
    number: 34,
    domain: 'sembo.com.ec',
    domainRedirected: 'sembo.es',
    isSubdomain: false,
    locale: 'es',
    fullLocale: 'es-EC',
    name: 'Sembo',
    homePage: 'https://www.sembo.com.ec',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'USD',
        currencySymbol: '$',
    },
};

export const semboUruguayanCompanyData: Market = {
    number: 35,
    domain: 'sembo.com.uy',
    domainRedirected: 'sembo.es',
    isSubdomain: false,
    locale: 'es',
    fullLocale: 'es-UY',
    name: 'Sembo',
    homePage: 'https://www.sembo.com.uy',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'UYU',
        currencySymbol: '$U',
    },
};

export const semboIsraeliCompanyData: Market = {
    number: 36,
    domain: 'sembo.co.il',
    domainRedirected: 'sembo.com',
    isSubdomain: false,
    locale: 'he',
    fullLocale: 'he-IL',
    name: 'Sembo',
    homePage: 'https://www.sembo.co.il',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'ILS',
        currencySymbol: '₪',
    },
};

export const semboCroatianCompanyData: Market = {
    number: 37,
    domain: 'hr.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'hr',
    fullLocale: 'hr-HR',
    name: 'Sembo',
    homePage: 'https://hr.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'HRK',
        currencySymbol: 'kn',
    },
};

export const semboIndonesianCompanyData: Market = {
    number: 38,
    domain: 'id.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'id',
    fullLocale: 'id-ID',
    name: 'Sembo',
    homePage: 'https://id.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'IDR',
        currencySymbol: 'Rp',
    },
};

export const semboSouthKoreanCompanyData: Market = {
    number: 39,
    domain: 'kr.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ko',
    fullLocale: 'ko-KR',
    name: 'Sembo',
    homePage: 'https://kr.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: '.',
        currency: 'KRW',
        currencySymbol: '₩',
    },
};

export const semboMalaysianCompanyData: Market = {
    number: 40,
    domain: 'my.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ms',
    fullLocale: 'ms-MY',
    name: 'Sembo',
    homePage: 'https://my.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'MYR',
        currencySymbol: 'RM',
    },
};

export const semboBelgianCompanyData: Market = {
    number: 41,
    domain: 'sembo.be',
    domainRedirected: 'sembo.nl',
    isSubdomain: false,
    locale: 'nl',
    fullLocale: 'nl-BE',
    name: 'Sembo',
    homePage: 'https://www.sembo.be',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: dutchFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboBrazilianCompanyData: Market = {
    number: 42,
    domain: 'sembo.com.br',
    domainRedirected: 'sembo.pt',
    isSubdomain: false,
    locale: 'pt',
    fullLocale: 'pt-BR',
    name: 'Sembo',
    homePage: 'https://www.sembo.com.br',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'BRL',
        currencySymbol: 'R$',
    },
};

export const semboRomanianCompanyData: Market = {
    number: 43,
    domain: 'sembo.ro',
    domainRedirected: 'sembo.com',
    isSubdomain: false,
    locale: 'ro',
    fullLocale: 'ro-RO',
    name: 'Sembo',
    homePage: 'https://www.sembo.ro',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'RON',
        currencySymbol: 'lei',
    },
};

export const semboSerbianCompanyData: Market = {
    number: 44,
    domain: 'rs.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'sr',
    fullLocale: 'sr-RS',
    name: 'Sembo',
    homePage: 'https://rs.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'RSD',
        currencySymbol: 'Дин.',
    },
};

export const semboRussianCompanyData: Market = {
    number: 45,
    domain: 'sembo.ru',
    isSubdomain: false,
    locale: 'ru',
    fullLocale: 'ru-RU',
    name: 'Sembo',
    homePage: 'https://www.sembo.ru', //blocked
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'RUB',
        currencySymbol: '₽',
    },
};

export const semboSlovakianCompanyData: Market = {
    number: 47,
    domain: 'sk.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'sk',
    fullLocale: 'sk-SK',
    name: 'Sembo',
    homePage: 'https://sk.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboThaiCompanyData: Market = {
    number: 48,
    domain: 'th.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'th',
    fullLocale: 'th-TH',
    name: 'Sembo',
    homePage: 'https://th.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'THB',
        currencySymbol: '฿',
    },
};

export const semboVietnameseCompanyData: Market = {
    number: 49,
    domain: 'vn.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'vi',
    fullLocale: 'vi-VN',
    name: 'Sembo',
    homePage: 'https://vn.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: ',',
        currency: 'VND',
        currencySymbol: '₫',
    },
};

export const semboTaiwaneseCompanyData: Market = {
    number: 50,
    domain: 'tw.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'zh',
    fullLocale: 'zh-TW',
    name: 'Sembo',
    homePage: 'https://tw.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'TWD',
        currencySymbol: 'NT$',
    },
};

export const semboHongKongeseCompanyData: Market = {
    number: 51,
    domain: 'hk.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'zh',
    fullLocale: 'zh-HK',
    name: 'Sembo',
    homePage: 'https://hk.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'HKD',
        currencySymbol: '$',
    },
};

export const semboSwissCompanyData: Market = {
    number: 52,
    domain: 'ch.sembo.com',
    isSubdomain: true,
    locale: 'de',
    fullLocale: 'de-CH',
    name: 'Sembo',
    homePage: 'https://ch.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 HELSINGBORG, SCHWEDEN',
            },
            {
                text: 'Steuer-Nr.: 556529-1795',
            },
            {
                text: 'Sitz der Gesellschaft: Helsingborg',
            },
        ],
        [
            {
                text: 'Über Sembo',
                href: 'https://ch.sembo.com/ueber-uns.aspx',
            },
            {
                text: 'Datenschutzerklärung',
                href: OUR_POLICIES_PATH,
            },
        ],
        [
            {
                text: 'Insolvenzversicherung von Stena Line Travel Group AB über Kammarkollegiet',
                href: 'https://ch.sembo.com/ueber-uns/reisegarantie.aspx',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'CHF',
        currencySymbol: 'CHF',
    },
};

export const semboGreekCompanyData: Market = {
    number: 53,
    domain: 'sembo.gr',
    domainRedirected: 'sembo.com',
    isSubdomain: false,
    locale: 'el',
    fullLocale: 'el-GR',
    name: 'Sembo',
    homePage: 'https://www.sembo.gr',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboBahrainiCompanyData: Market = {
    number: 54,
    domain: 'bh.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ar',
    fullLocale: 'ar-BH',
    name: 'Sembo',
    homePage: 'https://bh.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 3,
        decimalSeparator: ',',
        currency: 'BHD',
        currencySymbol: '.د.ب',
    },
};

export const semboBelarusianCompanyData: Market = {
    number: 55,
    domain: 'by.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'be',
    fullLocale: 'be-BY',
    name: 'Sembo',
    homePage: 'https://by.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: ',',
        currency: 'BYN',
        currencySymbol: 'Br',
    },
};

export const semboBolivianCompanyData: Market = {
    number: 56,
    domain: 'bo.sembo.com',
    domainRedirected: 'sembo.es',
    isSubdomain: true,
    locale: 'es',
    fullLocale: 'es-BO',
    name: 'Sembo',
    homePage: 'https://bo.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'BOB',
        currencySymbol: '$b',
    },
};

export const semboChineseCompanyData: Market = {
    number: 57,
    domain: 'cn.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'zh',
    fullLocale: 'zh-CN',
    name: 'Sembo',
    homePage: 'https://cn.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'CNY',
        currencySymbol: '¥',
    },
};

export const semboCubanCompanyData: Market = {
    number: 58,
    domain: 'cu.sembo.com',
    domainRedirected: 'sembo.es',
    isSubdomain: true,
    locale: 'es',
    fullLocale: 'es-CU',
    name: 'Sembo',
    homePage: 'https://cu.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'CUP',
        currencySymbol: '₱',
    },
};

export const semboCypriotCompanyData: Market = {
    number: 59,
    domain: 'cy.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'el',
    fullLocale: 'el-CY',
    name: 'Sembo',
    homePage: 'https://cy.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboDominicanCompanyData: Market = {
    number: 60,
    domain: 'do.sembo.com',
    domainRedirected: 'sembo.es',
    isSubdomain: true,
    locale: 'es',
    fullLocale: 'es-DO',
    name: 'Sembo',
    homePage: 'https://do.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'DOP',
        currencySymbol: 'RD$',
    },
};

export const semboEgyptianCompanyData: Market = {
    number: 61,
    domain: 'eg.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ar',
    fullLocale: 'ar-EG',
    name: 'Sembo',
    homePage: 'https://eg.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EGP',
        currencySymbol: '£',
    },
};

export const semboEstonianCompanyData: Market = {
    number: 62,
    domain: 'sembo.ee',
    domainRedirected: 'sembo.com',
    isSubdomain: false,
    locale: 'et',
    fullLocale: 'et-EE',
    name: 'Sembo',
    homePage: 'https://www.sembo.ee',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboFrenchCompanyData: Market = {
    number: 63,
    domain: 'sembo.fr',
    isSubdomain: false,
    locale: 'fr',
    fullLocale: 'fr-FR',
    name: 'Sembo',
    homePage: 'https://www.sembo.fr',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, Suède',
            },
            {
                text: 'Numéro de registre: 556529-1795',
            },
            {
                text: 'Siège social: Helsingborg, Suède',
            },
        ],
        [
            {
                text: 'Politique de confidentialité',
                href: OUR_POLICIES_PATH,
            },
            {
                text: 'Conditions générales de Sembo',
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Travailler à Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboIcelandicCompanyData: Market = {
    number: 64,
    domain: 'sembo.is',
    domainRedirected: 'sembo.com',
    isSubdomain: false,
    locale: 'is',
    fullLocale: 'is-IS',
    name: 'Sembo',
    homePage: 'https://www.sembo.is',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'ISK',
        currencySymbol: 'kr',
    },
};

export const semboIranianCompanyData: Market = {
    number: 65,
    domain: 'ir.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'fa',
    fullLocale: 'fa-IR',
    name: 'Sembo',
    homePage: 'https://ir.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: ',',
        currency: 'IRR',
        currencySymbol: '﷼',
    },
};

export const semboItalianCompanyData: Market = {
    number: 66,
    domain: 'it.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'it',
    fullLocale: 'it-IT',
    name: 'Sembo',
    homePage: 'https://it.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboJapaneseCompanyData: Market = {
    number: 67,
    domain: 'jp.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ja',
    fullLocale: 'ja-JP',
    name: 'Sembo',
    homePage: 'https://jp.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: '.',
        currency: 'JPY',
        currencySymbol: '¥',
    },
};

export const semboJordanianCompanyData: Market = {
    number: 68,
    domain: 'jo.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ar',
    fullLocale: 'ar-JO',
    name: 'Sembo',
    homePage: 'https://jo.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 3,
        decimalSeparator: '.',
        currency: 'JOD',
        currencySymbol: 'JD',
    },
};

export const semboKazakhCompanyData: Market = {
    number: 69,
    domain: 'kz.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'kk',
    fullLocale: 'kk-KZ',
    name: 'Sembo',
    homePage: 'https://kz.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'KZT',
        currencySymbol: 'лв',
    },
};

export const semboKuwaitiCompanyData: Market = {
    number: 70,
    domain: 'kw.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ar',
    fullLocale: 'ar-KW',
    name: 'Sembo',
    homePage: 'https://kw.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 3,
        decimalSeparator: ',',
        currency: 'KWD',
        currencySymbol: 'KD',
    },
};

export const semboLuxembourgishCompanyData: Market = {
    number: 71,
    domain: 'lu.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'fr',
    fullLocale: 'fr-LU',
    name: 'Sembo',
    homePage: 'https://lu.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboMalteseCompanyData: Market = {
    number: 72,
    domain: 'mt.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'mt',
    fullLocale: 'mt-MT',
    name: 'Sembo',
    homePage: 'https://mt.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const semboOmaniCompanyData: Market = {
    number: 73,
    domain: 'om.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ar',
    fullLocale: 'ar-OM',
    name: 'Sembo',
    homePage: 'https://om.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 3,
        decimalSeparator: ',',
        currency: 'OMR',
        currencySymbol: '﷼',
    },
};

export const semboParaguayanCompanyData: Market = {
    number: 74,
    domain: 'py.sembo.com',
    domainRedirected: 'sembo.es',
    isSubdomain: true,
    locale: 'es',
    fullLocale: 'es-PY',
    name: 'Sembo',
    homePage: 'https://py.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: ',',
        currency: 'PYG',
        currencySymbol: 'Gs',
    },
};

export const semboQatariCompanyData: Market = {
    number: 75,
    domain: 'qa.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ar',
    fullLocale: 'ar-QA',
    name: 'Sembo',
    homePage: 'https://qa.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'QAR',
        currencySymbol: '﷼',
    },
};

export const semboSaudiCompanyData: Market = {
    number: 76,
    domain: 'sa.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'ar',
    fullLocale: 'ar-SA',
    name: 'Sembo',
    homePage: 'https://sa.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'SAR',
        currencySymbol: '﷼',
    },
};

export const semboTurkishCompanyData: Market = {
    number: 77,
    domain: 'tr.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'tr',
    fullLocale: 'tr-TR',
    name: 'Sembo',
    homePage: 'https://tr.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'TRY',
        currencySymbol: '₺',
    },
};

export const semboUkrainianCompanyData: Market = {
    number: 78,
    domain: 'ua.sembo.com',
    domainRedirected: 'sembo.com',
    isSubdomain: true,
    locale: 'uk',
    fullLocale: 'uk-UA',
    name: 'Sembo',
    homePage: 'https://ua.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: globalFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'UAH',
        currencySymbol: '₴',
    },
};

export const semboVenezuelanCompanyData: Market = {
    number: 79,
    domain: 've.sembo.com',
    domainRedirected: 'sembo.es',
    isSubdomain: true,
    locale: 'es',
    fullLocale: 'es-VE',
    name: 'Sembo',
    homePage: 'https://ve.sembo.com',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    footerInfo: spanishFooterInfo,
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'VES',
        currencySymbol: 'Bs.',
    },
};
